<div class="register-personal-data">
  <div class="row">
    <div class="col-12 register-personal-data_text mt-1">
      <div>{{'SI_REGISTER_DATA' | translate}}</div>
    </div>
    <div *ngIf="displayModeRegisterPatient === registerPatientDisplayModes.SELECTABLE"
         [ngClass]="wideResolution ? 'col-12 mt-2' : 'col-12 mb-2'">
      <si-label text="{{'SI_HAS_VISITED_OUR_CENTERS_BEFORE' | translate}}"></si-label>
      <div class="si-radio-button-container_horizontal">
        <si-radio-button id="registerPersonalDataRadioHasVisitedBefore"
                         name="registerPersonalDataRadioHasVisitedBefore"
                         text="SI_YES"
                         [(model)]="model.hasVisitedBefore"
                         [value]="true"
        ></si-radio-button>
        <si-radio-button id="registerPersonalDataRadioHasNotVisitedBefore"
                         name="registerPersonalDataRadioHasNotVisitedBefore"
                         text="SI_NO"
                         [(model)]="model.hasVisitedBefore"
                         [value]="false"
        ></si-radio-button>
      </div>
    </div>
    <ng-container *ngIf="(displayModeRegisterPatient !== undefined && displayModeRegisterPatient !== registerPatientDisplayModes.SELECTABLE)
                         || model.hasVisitedBefore !== undefined;
                         else hiddenInputWithValidator">
      <div [ngClass]="wideResolution ? 'col-12 col-lg-3 mt-2' : 'col-12'">
        <si-input id="registerPersonalDataName"
                  name="registerPersonalDataName"
                  text="SI_NAME"
                  placeholder="SI_WRITE_HERE"
                  [(model)]="model.firstName"
                  [autoFocus]="true"
                  rule="generic.alphabeticalNotNull"
        ></si-input>
      </div>
      <div [ngClass]="wideResolution ? 'col-12 col-lg-3 mt-2' : 'col-12 col-lg-6 mt-2'">
        <si-input id="registerPersonalDataSurname1"
                  name="registerPersonalDataSurname1"
                  text="SI_SURNAME_1"
                  placeholder="SI_WRITE_HERE"
                  [(model)]="model.surname1"
                  rule="generic.alphabeticalNotNull"
        ></si-input>
      </div>
      <div [ngClass]="wideResolution ? 'col-12 col-lg-3 mt-2' : 'col-12 col-lg-6 mt-2'">
        <si-input id="registerPersonalDataSurname2"
                  name="registerPersonalDataSurname2"
                  text="SI_SURNAME_2"
                  placeholder="SI_WRITE_HERE"
                  [(model)]="model.surname2"
                  rule="generic.alphabetical"
        ></si-input>
      </div>
      <div [ngClass]="wideResolution ? 'col-12 col-lg-3 mt-2' : 'col-12 col-lg-6 mt-2'">
        <si-datepicker id="registerPersonalDataBirthday"
                       name="registerPersonalDataBirthday"
                       text="SI_BIRTHDATE"
                       placeholder="CORE_DATEPICKER_L"
                       [(model)]="model.birthDate"
                       startOf="day"
                       [pastOrToday]="true"
                       [empty]="true"
                       rule="generic.fieldNotNull"
        ></si-datepicker>
      </div>
      <div [ngClass]="wideResolution ? 'col-12 col-lg-3 mt-2' : 'col-12 col-lg-6 mt-2'">
        <si-selector id="registerPersonalDataSex"
                     name="registerPersonalDataSex"
                     text="SI_GENDER"
                     placeholder="SI_SELECT_PLACEHOLDER"
                     [(model)]="model.gender"
                     path="/api/v1/list/GENDER/items"
                     [showClear]="false"
                     rule="generic.fieldNotNull"
        ></si-selector>
      </div>
      <div [ngClass]="wideResolution ? 'col-12 col-lg-3' : 'col-12'">
        <div class="row">
          <div class="col-12 col-sm-4 mt-2">
            <si-selector id="registerPersonalDataDocumentType"
                          name="registerPersonalDataDocumentType"
                          text="SI_IDENTIFICATION_DOCUMENT"
                          placeholder="SI_SELECT_PLACEHOLDER"
                          [(model)]="model.identityDocument.type"
                          path="/api/v1/identificationDocument/identity"
                          [showClear]="false"
                          rule="generic.fieldNotNull"
            ></si-selector>
          </div>
          <div class="col-12 col-sm-8 register-personal-data_double-line">
            <si-input id="registerPersonalDataDocumentValue"
                      name="registerPersonalDataDocumentValue"
                      placeholder="SI_WRITE_HERE"
                      [(model)]="model.identityDocument.value"
                      [hideLabel]="true"
                      [ruleRegex]="model.identityDocument.type?.regex"
                      ruleRegexErrorText="SI_RULES_ERROR_FORMAT"
                      rule="generic.fieldNotNull"
                      [validationExternalErrorText]="validationErrorTextIdentityDocument"
            ></si-input>
          </div>
        </div>
      </div>
      <div [ngClass]="wideResolution ? 'col-12 col-lg-3 mt-2' : 'col-12 mt-2'">
        <si-input id="registerPersonalDataMobile"
                  name="registerPersonalDataMobile"
                  text="SI_MOBILE"
                  placeholder="SI_WRITE_HERE"
                  type="tel"
                  [(model)]="model.phone.value"
                  rule="generic.fieldNotNullLength5-15"
        ></si-input>
      </div>
      <div [ngClass]="wideResolution ? 'col-12 col-lg-3 mt-2' : 'col-12 mt-2'">
        <si-input id="registerPersonalDataEmail"
                  name="registerPersonalDataEmail"
                  text="SI_EMAIL"
                  placeholder="SI_WRITE_HERE"
                  type="email"
                  [(model)]="model.email"
                  (modelChange)="onChangeEmail()"
                  rule="generic.emailNotNull"
        ></si-input>
      </div>
      <div [ngClass]="wideResolution ? 'col-12 col-lg-3 mt-2' : 'col-12 mt-2'">
        <si-input id="registerPersonalDataEmailConfirmation"
                  name="registerPersonalDataEmailConfirmation"
                  text="SI_EMAIL_CONFIRM"
                  placeholder="SI_WRITE_HERE"
                  type="email"
                  [(model)]="model.emailConfirm"
                  (modelChange)="onChangeEmailConfirm()"
                  rule="generic.emailNotNull"
                  [validationExternalErrorText]="validationErrorTextEmailConfirm"
        ></si-input>
      </div>
      <div [ngClass]="wideResolution ? 'col-12 col-lg-3 mt-2' : 'col-12 mt-2'">
        <si-selector id="registerPersonalDataNotificationLanguage"
                     name="registerPersonalDataNotificationLanguage"
                     text="SI_NOTIFICATION_LANGUAGE"
                     placeholder="SI_SELECT_PLACEHOLDER"
                     [(model)]="model.notificationLanguage"
                     [values]="languageValues"
                     valueAttr="id"
                     [showClear]="false"
                     rule="generic.fieldNotNull"
        ></si-selector>
      </div>
      <ng-container *ngIf="displayModeNHC !== undefined && displayModeHealthCard !== undefined && model.hasVisitedBefore !== false">
        <div *ngIf="displayModeNHC !== registerDisplayModes.HIDE || displayModeHealthCard !== registerDisplayModes.HIDE"
             class="w-100 pasi-line-lightgrey"
        ></div>
        <ng-container *ngIf="displayModeNHC !== registerDisplayModes.HIDE">
          <div [class.mb-2]="displayModeHealthCard !== registerDisplayModes.HIDE"
              [ngClass]="wideResolution ? 'col-12 col-lg-3' : 'col-12'">
            <si-input id="registerPersonalDataClinicHistory"
                      name="registerPersonalDataClinicHistory"
                      text="SI_CLINIC_HISTORY"
                      placeholder="SI_WRITE_HERE"
                      [(model)]="model.nhc"
                      tooltipIcon="icosun-help_circle font-color-main3-dark"
                      tooltipText="SI_NHC_CENTER"
                      tooltipPosition="right"
                      [rule]="(displayModeNHC === registerDisplayModes.MANDATORY) ? 'generic.fieldNotNull' : ''"
            ></si-input>
          </div>
        </ng-container>
        <div [ngClass]="wideResolution ? 'col-12 col-lg-3' : 'col-12'">
          <ng-container *ngIf="displayModeHealthCard !== registerDisplayModes.HIDE">
            <div class="row">
              <div class="col-12 col-sm-4">
                <si-selector id="registerPersonalDataHealthCardType"
                             name="registerPersonalDataHealthCardType"
                             text="SI_HEALTH_CARD"
                             placeholder="SI_SELECT_PLACEHOLDER"
                             [(model)]="model.healthCardDocument.type"
                             (modelChange)="onChangeHealthCardDocumentType()"
                             path="/api/v1/identificationDocument/healthCard"
                             [showClear]="false"
                             [rule]="(displayModeHealthCard === registerDisplayModes.MANDATORY) ? 'generic.fieldNotNull' : ''"
                ></si-selector>
              </div>
              <div class="col-12 col-sm-8 register-personal-data_double-line-hc">
                <si-input id="registerPersonalDataHealthCardValue"
                          name="registerPersonalDataHealthCardValue"
                          placeholder="SI_WRITE_HERE"
                          [(model)]="model.healthCardDocument.value"
                          [hideLabel]="true"
                          [disabled]="!model.healthCardDocument.type"
                          [ruleRegex]="model.healthCardDocument.type?.regex"
                          ruleRegexErrorText="SI_RULES_ERROR_FORMAT"
                          [rule]="(displayModeHealthCard === registerDisplayModes.MANDATORY) ? 'generic.fieldNotNull' : ''"
                ></si-input>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #hiddenInputWithValidator>
        <div [hidden]="true">
          <si-input id="registerHiddenValidator"
                    name="registerHiddenValidator"
                    type="hidden"
                    rule="generic.fieldNotNull"
          ></si-input>
        </div>
      </ng-template>
  </div>
</div>
